import { MonoMenuItem, MonoMenuEntree, MonoMenuCacheItem, MonoMenuEntreeRules, MonoMenuItemRules, NutritionException } from '@/models/mono-menu';

// Commented items are present in the underlying data but were not used
export const entreeMenuPassthrough: (keyof MonoMenuEntree)[] = [
  'itemId',
  'itemType',
  'itemName',
  'primaryFillingName',
  'unitPrice',
  'unitDeliveryPrice',
  // 'contentGroups'
];

export const entreeRulesMenuPassthrough: (keyof MonoMenuEntreeRules)[] = [
  'maxQuantity',
  'eligibleForDelivery',
  'maxContents',
  'maxCustomizations',
  'maxExtras',
  'maxHalfs',
  // 'maxExtrasPlusHalfs', this is in the menu but we dont use it anywhere
  'isItemAvailable',
  'isUniversal',
  'maxOnTheSideCustomizations'
];

export const entreeMMDPassthrough: (keyof MonoMenuEntree)[] = ['thumbnailUrl', 'nutrition', 'portion', 'tags', 'dietaryTags'];

entreeMenuPassthrough as (keyof MonoMenuEntree)[];

export const itemMenuPassthrough: (keyof MonoMenuItem)[] = ['itemType', 'itemName', 'unitPrice', 'unitDeliveryPrice', 'itemId']; //, 'customizations'];

export const itemRulesMenuPassthrough: (keyof MonoMenuItemRules)[] = [
  'unitCount',
  'eligibleForDelivery',
  // 'pricingReferenceItemId',
  'countTowardsCustomizationMax',
  'countTowardsContentMax',
  //'contentGroupName',
  'defaultContent',
  'isItemAvailable',
  'maxQuantity',
];

export const itemMMDPassthrough: (keyof MonoMenuItem)[] = ['thumbnailUrl', 'nutrition', 'portion', 'tags', 'dietaryTags'];

export const itemRulesMMDPassthrough: (keyof MonoMenuItemRules)[] = ['showCustomizationPrice'];

export enum EntreeCustomizationId {
  Double = -1001,
}

export const topLevelMenuMapDuplications = [
  ['Burrito Bowl', 'Bowl'],
  [`Kid's Meal`, 'KidsQuesadilla'],
  [`Kid's Meal`, 'KidsBYO'],
];

export enum utilityItemKeys {
  sidesEntree = 'CMG-Chips & Sides',
  drinksEntree = 'CMG-Drinks'
}

export const utilityEntrees: { [index: string]: MonoMenuEntree | any } = {
  [utilityItemKeys.sidesEntree]: {
    itemId: 'CMG-Chips & Sides',
    itemType: 'non-entree',
    itemName: 'Chips & Sides',
    unitPrice: 0,
    unitDeliveryPrice: 0,
    allowedItems: [],
    groups: [],
  },
  [utilityItemKeys.drinksEntree]: {
    itemId: 'CMG-Drinks',
    itemType: 'non-entree',
    itemName: 'Drinks',
    unitPrice: 0,
    unitDeliveryPrice: 0,
    allowedItems: [],
    groups: [],
  }
};

export const selectNoneMap: { [index: string]: { itemId: string; itemName: string } } = {
  BeansContentGroup: { itemId: 'NO_BEANS', itemName: 'No Beans' },
  RiceContentGroup: { itemId: 'NO_RICE', itemName: 'No Rice' },
  DipContentGroup: { itemId: 'NO_DIPS', itemName: 'No Included Sides' },
  DrinkContentGroup: { itemId: 'NO_DRINK', itemName: 'No Drink' },
  OptionContentGroup: { itemId: 'NO_OPTION', itemName: 'No Toppings' },
  SideContentGroup: { itemId: 'NO_SIDE', itemName: 'No Included Sides' },
  ToppingsContentGroup: {itemId: 'NO_INCLUDED_TOPPING', itemName: 'No Included Toppings' }
};

function createEmptyUtilityItem(itemId: string, itemName: string, contentGroupName: string): MonoMenuCacheItem {
  return {
    itemId,
    itemType: 'Empty',
    itemName,
    unitPrice: 0,
    unitDeliveryPrice: 0,
    customizations: {},
    thumbnailUrl: '/content/dam/chipotle/icons-and-animations/buttons/no-selection.svg',
    nutrition: Object.assign({}, emptyNutritionData),
    portion: {
      value: 0,
      unit: 'oz',
    },
    tags: [],
    rules: {
      unitCount: 1,
      eligibleForDelivery: true,
      pricingReferenceItemId: {},
      countTowardsCustomizationMax: 0,
      countTowardsContentMax: 1,
      contentGroupName: { Burrito: contentGroupName },
      defaultContent: false,
      isItemAvailable: true,
      showCustomizationPrice: false,
    },
  };
}

export const emptyNutritionData = {
  calc: 0,
  calf: 0,
  carb: 0,
  fibe: 0,
  iron: 0,
  prot: 0,
  satu: 0,
  sodi: 0,
  suga: 0,
  tcal: 0,
  tfat: 0,
  tran: 0,
  vita: 0,
  vitc: 0,
};

export const staticUtilityItems: { [index: string]: MonoMenuCacheItem } = {
  'SOLO_TORTILLA_CMG-4025': {
    itemId: 'CMG-4025',
    itemType: 'Tortilla',
    itemName: 'Tortilla',
    unitPrice: 0.0,
    unitDeliveryPrice: 0.0,
    thumbnailUrl: 'https://www-int.chipotle.com/content/dam/chipotle/global/menu/menu-items/cmg-5501-flour-tortilla-burrito-size/web-mobile/order.jpg',
    customizations: {},
    nutrition: {},
    portion: {
      value: 4,
      unit: 'oz',
    },
    tags: [],
    rules: {
      unitCount: 1,
      eligibleForDelivery: true,
      isItemAvailable: true,
      showCustomizationPrice: false,
      contentGroupName: {},
      pricingReferenceItemId: {},
    },
  },
  'QUESADILLA_CHEESE_CMG-5252': {
    itemId: 'CMG-5252',
    itemType: 'Toppings',
    itemName: 'Cheese',
    unitPrice: 0,
    unitDeliveryPrice: 0,
    customizations: {},
    thumbnailUrl: 'https://www-int.chipotle.com/content/dam/chipotle/global/menu/menu-items/cmg-5252-monterey-jack-cheese/web-mobile/order.png',
    nutrition: {
      calc: 20,
      calf: 70,
      carb: 1,
      fibe: 0,
      iron: 0,
      prot: 6,
      satu: 5,
      sodi: 190,
      suga: 0,
      tcal: 110,
      tfat: 8,
      tran: 0,
      vita: 7,
      vitc: 0,
    },
    portion: {
      unit: 'oz',
      value: 3,
    },
    tags: [],
    dietaryTags: ['vege', 'keto', 'dair'],
    rules: {
      unitCount: 1,
      eligibleForDelivery: true,
      countTowardsCustomizationMax: 0,
      countTowardsContentMax: 0,
      defaultContent: false,
      isItemAvailable: true,
      contentGroupName: {},
      pricingReferenceItemId: {},
      showCustomizationPrice: false,
    },
  },
};

export const utilityItems: { [index: string]: MonoMenuCacheItem } = (() => {
  const utilityItems = Object.assign({}, staticUtilityItems);
  Object.keys(selectNoneMap).forEach(key => {
    utilityItems[selectNoneMap[key].itemId] = createEmptyUtilityItem(selectNoneMap[key].itemId, selectNoneMap[key].itemName, key);
  });
  return utilityItems;
})();

export const linkedEntreeTypeOptionTacos = {
  title: 'QUANTITY',
  typeOptions: [
    {
      optionTitle: 'Three Tacos',
      optionDefaultEntreeId: 'CMG-201',
    },
    {
      optionTitle: 'One Taco',
      optionDefaultEntreeId: 'CMG-1201',
    },
  ],
};

export const linkedEntreeTypeOptionKids = {
  title: 'Choose Meal Type',
  typeOptions: [
    {
      optionTitle: 'Kid’s Build Your Own',
      optionDefaultEntreeId: 'CMG-3002',
    },
    {
      optionTitle: 'Kid’s Quesadilla',
      optionDefaultEntreeId: 'CMG-3102',
    },
  ],
};

export const includedItemsByType: { [index: string]: string[] | null } = {
  Burrito: ['SOLO_TORTILLA_CMG-4025'],
  Bowl: null,
  Quesadilla: ['SOLO_TORTILLA_CMG-4025', 'QUESADILLA_CHEESE_CMG-5252'],
  Salad: ['CMG-5351'],
  Tacos: null,
  KidsBYO: null,
  KidsQuesadilla: ['CMG-5401', 'CMG-5252']
};

export const excludedContentGroupsByType:  { [index: string]: string[] | null } = {
  Burrito: null,
  Bowl: null,
  Quesadilla: null,
  Salad: null,
  Tacos: null,
  KidsBYO: null,
  KidsQuesadilla: ['Tortilla'], // This group needs to come through MMD for MBv1
}

export const exludedUniversalItems = ['CMG-5557']; // Apple and Eve Apple Juice

export const excludedUniversalItemsByCountry:  { [index: string]: string[] | null } = {
  CA: ['CMG-5553', 'CMG-5554'], // Hide US Milk
  US: ['CMG-2841', 'CMG-2842']  // Hide CA Milk
}

export const linkedSidesMap: { [index: string]: string | undefined } = {
  'CMG-1001': 'CMG-1207',
  'CMG-1029': 'CMG-1034',
  'CMG-1207': 'CMG-1001',
  'CMG-1034': 'CMG-1029'
};

export const linkedVeggieToNonVeggieMap: { [index: string]: string | undefined } = {
  'CMG-1034': 'CMG-1029', // Queso
  'CMG-5301': 'CMG-1001' // Guac
};

export const linkedNonVeggieToVeggieMap: { [index: string]: string | undefined } = {
  'CMG-1029': 'CMG-1034', // Queso
  'CMG-1001': 'CMG-5301' // Guac
};

export const requiredNutritionFields = [
  'calc',
  'calf',
  'carb',
  //'chol', // Cholesterol is included in some of our data but not all. We've left it in the spec in case product requests it later
  'fibe',
  'iron',
  'prot',
  'satu',
  'sodi',
  'suga',
  'tcal',
  'tfat',
  'tran',
  'vita',
  'vitc',
];

const nutritionExceptionsUS: NutritionException[] = [
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-3011', nutrition: { carb: 2, prot: 2, tcal: 60, tfat: 5, calf: 40, satu: 3, tran: 0, fibe: 0, suga: 1, sodi: 125, vita: 4, vitc: 0, iron: 0, calc: 4 } }, // Queso Blanco
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5051', nutrition: { carb: 16, prot: 6, tcal: 100, tfat: 1, calf: 10, satu: 0, tran: 0, fibe: 5, suga: 1, sodi: 160, vita: 2, vitc: 2, iron: 8, calc: 3 } }, // Black Beans
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5052', nutrition: { carb: 15, prot: 6, tcal: 100, tfat: 1, calf: 10, satu: 0, tran: 0, fibe: 6, suga: 1, sodi: 160, vita: 0, vitc: 2, iron: 8, calc: 3 } }, // Pinto Beans
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5201', nutrition: { carb: 1, prot: 0, tcal: 15, tfat: 0, calf: 0, satu: 0, tran: 0, fibe: 0, suga: 1, sodi: 310, vita: 0, vitc: 8, iron: 3, calc: 0 } }, // Fresh Tomato Salsa
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5202', nutrition: { carb: 9, prot: 1, tcal: 40, tfat: 1, calf: 10, satu: 0, tran: 0, fibe: 1, suga: 3, sodi: 190, vita: 2, vitc: 5, iron: 0, calc: 0 } }, // Roasted Chili-Corn Salsa
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5251', nutrition: { carb: 1, prot: 1, tcal: 60, tfat: 5, calf: 45, satu: 4, tran: 0, fibe: 0, suga: 1, sodi: 15, vita: 4, vitc: 0, iron: 0, calc: 3 } }, // Sour Cream
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5002', nutrition: { carb: 18, prot: 2, tcal: 110, tfat: 3, calf: 25, satu: 1, tran: 0, fibe: 1, suga: 0, sodi: 95, vita: 1, vitc: 1, iron: 2, calc: 0 } }, // Brown Rice
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5001', nutrition: { carb: 20, prot: 2, tcal: 100, tfat: 2, calf: 20, satu: 0, tran: 0, fibe: 0, suga: 0, sodi: 170, vita: 0, vitc: 1, iron: 1, calc: 0 } }, // White Rice
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5403', nutrition: { carb: 19, prot: 2, tcal: 130, tfat: 6, calf: 50, satu: 1, tran: 0, fibe: 2, suga: 0, sodi: 0, vita: 0, vitc: 0, iron: 4, calc: 11 } }, // 2 Crispy Corn Tortillas
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-3014', nutrition: { carb: 8, prot: 8, tcal: 110, tfat: 4, calf: 40, satu: 1, tran: 0, fibe: 3, suga: 1, sodi: 340, vita: 60, vitc: 0, iron: 20, calc: 6 } } // Plant Based Chorizo
];

const nutritionExceptionsCA: NutritionException[] = [
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-3011', nutrition: { carb: 2, prot: 2, tcal: 60, tfat: 5, calf: 40, satu: 3, tran: 0, fibe: 0, suga: 1, sodi: 125, vita: 4, vitc: 0, iron: 0, calc: 4 } }, // Queso Blanco
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5051', nutrition: { carb: 16, prot: 6, tcal: 100, tfat: 1, calf: 10, satu: 0, tran: 0, fibe: 5, suga: 1, sodi: 160, vita: 2, vitc: 2, iron: 8, calc: 3 } }, // Black Beans
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5052', nutrition: { carb: 15, prot: 6, tcal: 100, tfat: 1, calf: 10, satu: 0, tran: 0, fibe: 6, suga: 1, sodi: 160, vita: 0, vitc: 2, iron: 8, calc: 3 } }, // Pinto Beans
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5201', nutrition: { carb: 1, prot: 0, tcal: 15, tfat: 0, calf: 0, satu: 0, tran: 0, fibe: 0, suga: 1, sodi: 310, vita: 0, vitc: 8, iron: 3, calc: 0 } }, // Fresh Tomato Salsa
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5202', nutrition: { carb: 9, prot: 1, tcal: 40, tfat: 1, calf: 10, satu: 0, tran: 0, fibe: 1, suga: 3, sodi: 190, vita: 2, vitc: 5, iron: 0, calc: 0 } }, // Roasted Chili-Corn Salsa
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5251', nutrition: { carb: 2, prot: 1, tcal: 45, tfat: 4, calf: 35, satu: 2.5, tran: 0, fibe: 0, suga: 1, sodi: 20, vita: 4, vitc: 0, iron: 0, calc: 0 } }, // Sour Cream
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5002', nutrition: { carb: 18, prot: 2, tcal: 110, tfat: 3, calf: 25, satu: 1, tran: 0, fibe: 1, suga: 0, sodi: 95, vita: 1, vitc: 1, iron: 2, calc: 0 } }, // Brown Rice
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5001', nutrition: { carb: 20, prot: 2, tcal: 100, tfat: 2, calf: 20, satu: 0, tran: 0, fibe: 0, suga: 0, sodi: 170, vita: 0, vitc: 1, iron: 1, calc: 0 } }, // White Rice
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-5403', nutrition: { carb: 19, prot: 2, tcal: 130, tfat: 6, calf: 50, satu: 1, tran: 0, fibe: 2, suga: 0, sodi: 0, vita: 0, vitc: 0, iron: 4, calc: 11 } }, // 2 Crispy Corn Tortillas
  { topLevelMenuTitle: `Kid's Meal`, itemId: 'CMG-3014', nutrition: { carb: 8, prot: 8, tcal: 110, tfat: 4, calf: 40, satu: 1, tran: 0, fibe: 3, suga: 1, sodi: 340, vita: 60, vitc: 0, iron: 20, calc: 6 } } // Plant Based Chorizo
]

export const nutritionExceptions: NutritionException[] = window._locale === 'CA' ? nutritionExceptionsCA : nutritionExceptionsUS;

export const allowedNoNutritionItemTypes = ['ExtraPortion', 'HalfPortion'];
export const excludedItemTypes = ['Tractor', 'Tractor RTD', 'Soda'];
